import type { TraditionalAction } from "./reducer";

// Estado de UI LOCAL do módulo (não entra no doc, não é desfazível).
export interface TraditionalUi {
  selectedKey: string | null;
}

export const initialTraditionalUi: TraditionalUi = { selectedKey: null };

/** Chave de coalescing do undo: digitar uma dica inteira = um undo. */
export function coalesceKeyFor(a: TraditionalAction): string | null {
  switch (a.type) {
    case "SET_CHAVE":
      return `chave:${a.key}`;
    case "SET_TITULO":
      return "titulo";
    default:
      return null;
  }
}
